import React from 'react';
import laborImg from '../../assets/images/labor.svg';
import { usePaywallContext } from '../../contexts/paywall';
import { Subscription } from '../../services/models/subscription';

interface InactiveSubscriptionProps {
  title?: string;
  description?: string;
  subscription: Subscription;
}

export default function InactiveSubscription(props: InactiveSubscriptionProps) {
  const { setPaywallModalShown } = usePaywallContext();

  const title = props.title ? props.title : 'See the latest news for your network';
  const description = props.description
    ? props.description
    : 'Purchase a Newslit plan to start seeing news today';

  const handleBuyNowClick = () => {
    setPaywallModalShown(true);
  };

  return (
    <div className="flex h-full justify-center items-center bg-blur-dashboard bg-no-repeat bg-center text-center">
      <div>
        <div className="flex justify-center">
          <img className="w-72" src={laborImg} alt="upgrade" />
        </div>

        <h2 className="font-bold text-xl md:text-3xl">{title}</h2>

        <p className="mt-4 px-4 max-w-2xl mx-auto text-center text-lg md:text-xl text-gray-600">
          {description}
        </p>

        <div className="mt-4 text-center">
          <button
            type="button"
            className="inline-flex items-center px-6 py-3 border border-transparent shadow-xs text-base font-bold rounded-md text-white bg-secondary hover:bg-secondary-dark hover:text-white hover:no-underline focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-secondary"
            onClick={handleBuyNowClick}
          >
            Upgrade Now
          </button>
        </div>
      </div>
    </div>
  );
}
